import OnBoarding from '@/views/onBoarding/OnBoarding.vue'
import ManageTaxonomy from '@/views/onBoarding/ManageTaxonomy.vue'
import ManageDataEntry from '@/views/onBoarding/ManageDataEntry.vue'
import CClone from '@/views/onBoarding/CClone.vue'
import Partners from '@/views/onBoarding/Partners.vue'
import Georadar from '@/views/onBoarding/Georadar.vue'

const routes = [
    {
        component: OnBoarding,
        name: 'on-boarding',
        path: '/:account_id/on-boarding',
        redirect: '/:account_id/on-boarding/manage-taxonomy',
        children: [
            {
                path: 'manage-taxonomy',
                name: 'on-boarding-manage-taxonomy',
                component: ManageTaxonomy
            },
            {
                path: 'manage-data-entry',
                name: 'on-boarding-manage-data-entry',
                component: ManageDataEntry
            },
            {
                path: 'cclone',
                name: 'on-boarding-cclone',
                component: CClone
            },
            {
                path: 'partners',
                name: 'partners',
                component: Partners
            },
            {
                path: 'georadar',
                name: 'georadar',
                component: Georadar
            }
        ]
    }
]

export default routes
